import { Lookup } from "@data-types";
import { LanguageDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformTitlesApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/languages`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findLanguages(
		isos: string
	): Promise<Lookup<LanguageDataType>> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?sort=name|asc&rpp=1000&translate=true&isos=${isos}`,
				this.getRequestHeaders()
			)
		);

		return response;
	}
}

export default PlatformTitlesApiService;
